// Modify sections

export const SORT_SECTION_ITEMS = "SORT_SECTION_ITEMS";

// Dragging
export const SET_DRAGGING_ENTITY = "SET_DRAGGING_ENTITY";
